import React, { PureComponent, createRef } from "react";
import Carousel from "react-elastic-carousel";

class UseCasesCarousel extends PureComponent {
  constructor(props) {
    super(props);
    this.resetTimeout = null;
    this.catouselRefMD = createRef();
    this.catouselRefLG = createRef();
    this.catouselRefXL = createRef();
    this.catouselRefSM = createRef();
  }
  eventCard = (event, index) => (
    <div
      className="usecases-card d-flex mr-3 flex-column align-items-center justify-content-center"
      title={event.name}
      key={index}
    >
      <div className="d-flex flex-column">
        <img
          src={event.image}
          className="w-100 h-100"
          alt={event.name}
          loading="lazy"
        />
      </div>
    </div>
  );

  onNextStart = (currentItem, nextItem, element) => {
    if (currentItem.index === nextItem.index) {
      element.current.goTo(0);
    }
  };

  onPrevStart = (currentItem, nextItem, element) => {
    if (currentItem.index === nextItem.index) {
      element.current.goTo(this.props.data.length);
    }
  };

  render() {
    const showDots = this.props.data.length <= 6;
    return (
      <>
        <div className="row g-0 py-3 py-md-0">
          <div className="col d-none d-md-block d-lg-none d-xl-none">
            <Carousel
              ref={this.catouselRefMD}
              itemsToShow={3}
              infinite={true}
              enableAutoPlay={true}
              autoPlaySpeed={2000}
              onNextStart={(currentItem, nextItem) =>
                this.onNextStart(currentItem, nextItem, this.catouselRefMD)
              }
              onPrevStart={(currentItem, nextItem) =>
                this.onPrevStart(currentItem, nextItem, this.catouselRefMD)
              }
              onNextEnd={() => {
                clearTimeout(this.resetTimeout);
                this.resetTimeout = setTimeout(() => {
                  this.catouselRefXL?.current?.goTo(0);
                }, 2000);
              }}
              disableArrowsOnEnd={false}
              disableArrowsOnStart={false}
              showArrows={false}
            >
              {this.props.data.map(this.eventCard)}
            </Carousel>
          </div>
          <div className="col d-none d-md-none d-lg-block d-xl-none">
            <Carousel
              ref={this.catouselRefLG}
              infinite={true}
              enableAutoPlay={true}
              itemsToShow={4}
              autoPlaySpeed={2000}
              onNextStart={(currentItem, nextItem) =>
                this.onNextStart(currentItem, nextItem, this.catouselRefLG)
              }
              onPrevStart={(currentItem, nextItem) =>
                this.onPrevStart(currentItem, nextItem, this.catouselRefLG)
              }
              onNextEnd={() => {
                clearTimeout(this.resetTimeout);
                this.resetTimeout = setTimeout(() => {
                  this.catouselRefXL?.current?.goTo(0);
                }, 2000);
              }}
              disableArrowsOnEnd={false}
              disableArrowsOnStart={false}
              showArrows={false}
            >
              {this.props.data.map(this.eventCard)}
            </Carousel>
          </div>
          <div className="col d-none d-md-none d-lg-none d-xl-block">
            <Carousel
              ref={this.catouselRefXL}
              itemsToShow={6}
              infinite={true}
              pagination={!showDots}
              autoPlaySpeed={2000}
              enableAutoPlay={true}
              onNextStart={(currentItem, nextItem) =>
                this.onNextStart(currentItem, nextItem, this.catouselRefXL)
              }
              onPrevStart={(currentItem, nextItem) =>
                this.onPrevStart(currentItem, nextItem, this.catouselRefXL)
              }
              onNextEnd={() => {
                clearTimeout(this.resetTimeout);
                this.resetTimeout = setTimeout(() => {
                  this.catouselRefXL?.current?.goTo(0);
                }, 2000);
              }}
              disableArrowsOnEnd={false}
              disableArrowsOnStart={false}
              showArrows={false}
            >
              {this.props.data.map(this.eventCard)}
            </Carousel>
          </div>
          <div className="col d-block d-md-none d-lg-none d-xl-none">
            <Carousel
              ref={this.catouselRefSM}
              itemsToShow={1}
              infinite={true}
              autoPlaySpeed={2000}
              enableAutoPlay={true}
              onNextStart={(currentItem, nextItem) =>
                this.onNextStart(currentItem, nextItem, this.catouselRefSM)
              }
              onPrevStart={(currentItem, nextItem) =>
                this.onPrevStart(currentItem, nextItem, this.catouselRefSM)
              }
              onNextEnd={() => {
                clearTimeout(this.resetTimeout);
                this.resetTimeout = setTimeout(() => {
                  this.catouselRefXL?.current?.goTo(0);
                }, 2000);
              }}
              disableArrowsOnEnd={false}
              disableArrowsOnStart={false}
              showArrows={false}
            >
              {this.props.data.map(this.eventCard)}
            </Carousel>
          </div>
        </div>
        <style jsx>
          {`
            .usecases-card {
              background: #23313e;
              box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.25);
              border: 4px solid #ffffff;
              border-radius: 0.5px;
              margin: 20px;
            }
            @media screen and (max-width: 480px) {
              .usecases-card {
                margin: 0px;
              }
            }
          `}
        </style>
      </>
    );
  }
}

export default UseCasesCarousel;
